const typeOf = x => Object.prototype.toString.call(x).slice(8, -1)

// https://help.klaviyo.com/hc/en-us/articles/115005080127-How-to-add-custom-fields-to-a-legacy-form#special-fields-in-klaviyo8
const DOLLAR_PREFIX_FIELDS = ['first_name', 'last_name', 'phone_number', 'organization', 'title']

/**
 * 
 * @param values - [object | HTMLFormElement | FormData] 
 * @returns object - Key/value pair
 */
function gatherFormValues(values) {
  let data = {};
  let fd = null

  if (values instanceof HTMLFormElement) {
    fd = new FormData(values)
  } else if (values instanceof FormData) {
    fd = values
  } else if (typeOf(values) === 'Object') {
    return values
  }

  if (!(fd instanceof FormData)) {
    throw new Error('Form data not found')
  }

  fd.forEach((value, key) => {
    value = typeof value === 'string' ? value.trim() : value
    
    // Remove `bis` from the keys
    // key = key.slice(0, 4) === 'bis_' ? key.slice(4) : key

    // Prefix `$` on resevered fields
    if (DOLLAR_PREFIX_FIELDS.includes(key)) key = '$' + key

    if (value) {
      if (key == 'name') {
        const nameParts = value.split(' ').filter(Boolean)

        if (nameParts[0]) {
          data.$first_name = nameParts[0]
        }
        if (nameParts[1]) {
          data.$last_name = nameParts.slice(1).join(' ')
        }
      } else {
        if (data[key]) {
          if (!Array.isArray(data[key])) {
            data[key] = [data[key]]
          }
          data[key].push(value)
        } else {
          data[key] = value
        }
      }
    }
  });
  
  return data
}


/**
 *
 * @example:
 * <form is="x-print-form" id="custom_kaviyo_form">
 *   <input name="a" type="hidden" value="<KLAVIYO ACCOUNT ID>">
 *   <input name="g" type="hidden" value="<KLAVIYO LIST ID>">
 *   <input name="$fields" type="hidden" value="favorite_colors">
 * 
 *   <input name="product" type="hidden" value="123_ABC">
 *   <input name="variant" type="hidden" value="123_ABC">
 * 
 *   <input name="first_name" type="text" placeholder="first name" value="jack">
 *   <input name="last_name" type="text" placeholder="last name" value="son">
 *   <input name="email" type="email" required="" placeholder="email" value="jackson123@gmail.com">
 * 
 *   <div class="checkboxes">
 * 
 *     <div class="checkbox">  
 *       <label>Red</label>
 *       <input type="checkbox" name="favorite_colors" value="Red" />
 *     </div>
 * 
 *     <div class="checkbox">  
 *       <label>Blue</label>
 *       <input type="checkbox" name="favorite_colors" value="Blue" />
 *     </div>
 *
 *     <div class="checkbox">  
 *       <label>Green</label>
 *       <input type="checkbox" name="favorite_colors" value="Green" />
 *     </div>
 *
 *     </div>
 *   <button type="submit">Notify me</button>
 * </form>
 *
 */
async function klaviyoApiRequest(url, values) {
  let data = gatherFormValues(values)

  if (data._debug) {
    console.log('POST data::', data)
    return new Promise((f, r) => {
      let delay = 800
      let args =  Math.random() < 0.5 ? [f, delay, { ok: true, error: null, data }] : [f, delay, { ok: false, error: 'Oops! Unable to complete the request. (fake)', data}]
      console.log(args)
      setTimeout.apply(this, args)
    })
  }

  if (!data.a) {
    throw new Error('Klaviyo account id is missing')
    console.log('POST data::', data)
    return
  }

  if (!data.g) {
    console.warn('Klaviyo list id is missing')
    console.log('POST data::', data)
  }

  return fetch(url, {
    "headers": {
      "accept": "*/*",
      "accept-language": "en-US,en;q=0.9",
      "content-type": "application/x-www-form-urlencoded",
    },
    "body": new URLSearchParams(data).toString(),
    "method": "POST",
    "mode": "cors",
    "credentials": "omit"
  })
  .then(r => r.json())
  .then(r => {
    if (r && r.status == 200 || r.success) {
      return {
        ok: true,
        error: null
      } 
    }
    
    console.warn('Klaviyo failed response => ', r)
    let errMsg = typeof r === 'string' ? r : null

    if (!errMsg) {
      errMsg = r && typeof r.error == 'string' ? r.error : 'Oops! Unable to complete the request.'
    }

    return {
      ok: false,
      error: errMsg
    }
  })
}

export const { 
  post,
  postBackInStock,
  postNewsletter
} = {
  post: klaviyoApiRequest,
  postBackInStock: klaviyoApiRequest.bind(null, 'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe'),
  postNewsletter: klaviyoApiRequest.bind(null, 'https://a.klaviyo.com/ajax/subscriptions/subscribe')
}

// ------------------------------------------------
// ------------------------------------------------
// ------------------------------------------------

/*
if (!customElements.get('x-print-form')) {
  class XPrintForm extends HTMLFormElement {
    connectedCallback() {
      this._ac?.abort()
      this._ac = new AbortController()
    
      this.addEventListener('submit', e => {
        e.preventDefault();
        const dataObj = gatherFormValues(this)
        window._data = dataObj
        console.log('Data =>',dataObj);
      }, { signal: this._ac.signal })
    }

    disconnectedCallback() {
      this._ac.abort()
      this._ac = null
    }
  }
  
  customElements.define('x-print-form', XPrintForm, { extends: 'form' })
}

const app = document.getElementById('app') || document.createElement('app');
if (!document.body.contains(app)) {
  const sub = document.getElementById('subtitle');
  sub.insertAdjacentElement('beforebegin', app)
}

app.innerHTML = `
<style>
  .checkboxes {
    display: flex;
    flex-wrap: wrap;
    gap: 1.8rem;
  }

  .checkboxes .checkbox {
      display: flex;
      align-items: center;
      gap: 10px;
  }
</style>
<form is="x-print-form" id="custom_kaviyo_form">
  <input name="a" type="hidden" value="<KLAVIYO ACCOUNT ID>">
  <input name="g" type="hidden" value="<KLAVIYO LIST ID>">
  <input name="$fields" type="hidden" value="favorite_colors">

  <input name="product" type="hidden" value="123_ABC">

  <input name="first_name" type="text" placeholder="first name" value="jack">
  <input name="last_name" type="text" placeholder="last name" value="son">
  <input name="email" type="email" required="" placeholder="email" value="jackson123@gmail.com">

  <div class="checkboxes">

    <div class="checkbox">  
      <label>Red</label>
      <input type="checkbox" name="favorite_colors" value="Red" />
    </div>

    <div class="checkbox">  
      <label>Blue</label>
      <input type="checkbox" name="favorite_colors" value="Blue" />
    </div>

    <div class="checkbox">  
      <label>Green</label>
      <input type="checkbox" name="favorite_colors" value="Green" />
    </div>

  </div>
  <button type="submit">Notify me</button>
</form>
`

*/
